export const API = 'API'
export const API_ERROR = 'API_ERROR'
